import __ from "web/Layout/Translations";

import formatNumber from "web/utils/data/parser/number/formatNumber";

import { RentableGroupCalculatorCopy } from "../const/rentableGroupCalculatorCopy";
import RentableGroupCalculatorHtmlContent from "../RentableGroupCalculatorHtmlContent";
import classes from "./rentableGroupCalculatorTotalIncomeMessage.scss";

interface IRentableGroupCalculatorTotalIncomeMessageProps {
  totalIncome: number;
  calculatorCopy: RentableGroupCalculatorCopy;
}

const RentableGroupCalculatorTotalIncomeMessage = ({
  totalIncome,
  calculatorCopy,
}: IRentableGroupCalculatorTotalIncomeMessageProps) => {
  const { totalIncomeTooHigh } = calculatorCopy || {};

  return (
    <div className={classes.root}>
      <p>
        <RentableGroupCalculatorHtmlContent
          as="span"
          html={totalIncomeTooHigh}
        />{" "}
        {formatNumber(totalIncome)} {__("zł")}.
      </p>
    </div>
  );
};

export default RentableGroupCalculatorTotalIncomeMessage;
